import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.729 12.473v1.093c.352.074.593.222.593.39 0 .24-.5.426-1.093.426-.612 0-1.094-.185-1.094-.426 0-.167.24-.316.593-.39v-1.5c-.093-.038-.185-.094-.297-.13C1.131 10.303 0 12.583 0 13.548c0 1.89 3.95 3.022 7.602 3.022 3.653 0 7.398-1.094 7.398-2.04.018-.89-4.765-.352-9.271-2.058Zm8.186-9.792s-2.827-.025-4.013.42c-.594.222-1.688 2.092-2.633 2.518a4.614 4.614 0 0 1-1.837.39v7.855a.204.204 0 0 1-.408 0V.644a.345.345 0 0 1-.037-.13.266.266 0 0 1 .26-.26c.148 0 .221.11.221.26a.267.267 0 0 1-.037.13v.221c.315.204.983.538 2.17.686.686.093 1.483-.018 2.187-.018 1.039-.019 4.125 1.148 4.125 1.148"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent
